import $ from 'jquery';

import 'slick-carousel';

import BaseComponent from '@/components/base';

import { FontStyle } from '@/components/style';
import { SliderStyle } from '@/components/style/slider-style';

export default class ReviewCarousel extends BaseComponent {
  render() {
    return `
    ${FontStyle}
    ${SliderStyle}
    <style>
        .carousel-container {
            width: 100%;
        }
        .review-container {
            background-color: #F7FAFA;
            display: flex;
            flex-direction: column;

            ${
              this.isSmall
                ? `padding-top: 40px;
                   padding-left: 12px;
                   padding-right: 12px;
                   gap: 16px`
                : `padding-top: 60px;
                   padding-bottom: 60px;
                   padding-left: 7%;
                   padding-right: 7%;
                   gap: 24px`
            }
        }
        .review-image {
            min-width: 142px;
            min-height: 142px;
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 11px 0px 0px 11px;
        }

        .card {
        display: flex !important;
        flex-direction: row;
        border-radius: 11px;
        ${!this.isSmall ? `min-width: 400px;max-width: 400px;` : ''}
        }

        .slick-dots {
            justify-content: center;
            top: 16px;
            position: relative;
            gap: 13px;
        }
        .slick-dots li {
            width: 100%;
            max-width: 82px;
        }
        .slick-dots li button {
            width: 100%;
            height: 1.5px;
            background: #D2EAE5;
            border-radius: 0;
            opacity: 1;
            margin: 0;
            padding: 0px;
        }
        .slick-dots li.slick-active button {
            background: #8AE5D3;
        }

        .desktop-container {
            display: flex;
            gap: 16px;
            justify-content: center;
        }
    </style>

    <div class="review-container">
        <div class="title-font-5 review-title">
            Real Repair, Real Joy
        </div>
        <div class="carousel-container" ${
          !this.isSmall && `style="display: none"`
        }>
             ${this.getCards()}
        </div>

        <div class="desktop-container" ${
          this.isSmall && `style="display: none"`
        }>
            ${this.getCards()}
        </div>
    </div>`;
  }

  get cards() {
    const cardAttribute = this.getAttribute('cards') || '[]';
    const urlParams = new URLSearchParams(window.location.search);
    const productType = urlParams.get('product_type') || 'core';
    return JSON.parse(cardAttribute).filter(
      (card) => card.type === productType
    );
  }

  getCards() {
    return `
     ${this.cards
       .map(
         (card) =>
           `<div class="card">
                    <div
                        class="review-image"
                        style="background-image: url('${card.image}')"
                        >

                    </div>
                    <div style="display: flex; flex-direction: column; padding: 20px; gap: 10px; background-color: ${
                      card.backgroundColor
                    }; border-radius: 0px 11px 11px 0px;">
                        <div>${Array.from({ length: card.stars })
                          .map(() => '★')
                          .join('')}</div>
                        <div class="body-font-2">"${card.comment}"</div>
                        <div class="body-font-2">${card.name}</div>
                    </div>
                 </div>`
       )
       .join('')}
    `;
  }

  connectedCallback() {
    const slickElement = $('.carousel-container', this.shadowRoot);

    slickElement.slick({ arrows: false, dots: true });
  }
}
